var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSingleLiveIcon = function SvgSingleLiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "1 of 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21480",
    fill: "none",
    d: "M0 0h14v14H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a5a5a5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108749",
    d: "M7.499 4.758a1.246 1.246 0 1 1-1.246-1.246 1.246 1.246 0 0 1 1.246 1.246Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108750",
    d: "M12.711 3.392 7.228.576a.5.5 0 0 0-.455 0L1.29 3.392a.5.5 0 0 0-.271.443v6.33a.5.5 0 0 0 .271.443l5.483 2.816a.5.5 0 0 0 .455 0l5.483-2.816a.5.5 0 0 0 .271-.443v-6.33a.5.5 0 0 0-.271-.443Zm-.726 3.757a4.508 4.508 0 0 0-1.994-1.145c-.684 0-2.053 1.155-2.847 1.882.3.217.514.386.584.441a.374.374 0 0 1-.463.587 9.969 9.969 0 0 0-3.256-1.913.816.816 0 0 0-.125.017 6.421 6.421 0 0 0-1.869 1.241v-4.12l4.984-2.56 4.984 2.56Z"
  }))));
};
export default SvgSingleLiveIcon;